import {loadScript} from "util/loadScript";

export default class YTPlayer {
    constructor($element, videoID, autoplay = true) {
        this.$element = $element;
        this.player = null;
        this.videoID = videoID;
        this.autoplay = autoplay;

        this.init();
    }

    init() {
        let me = this;
        loadScript("https://www.youtube.com/iframe_api", "YT");
        let checkYTStatus = setInterval(function(){
            if(YT.loaded === 1){
                me.load();
                clearInterval(checkYTStatus);
            }
        }, 200);
    };

    load() {
        let me = this;
        this.player = new YT.Player(me.$element.find('.js-video-container')[0], {
            videoId:  this.videoID,
            playerVars: {
                modestbranding: 1,
                rel: 0,
                autoplay: this.autoplay ? 1 : 0
            }
        });
    };
    stopVideo() {
        this.player.stopVideo();
    };
    startVideo() {
        let me = this;
        if (typeof me.player.playVideo !== 'function') {
            this.$element.addClass('loading');
            setTimeout(function () {
                me.startVideo();
            }, 100);
        } else {
            this.player.playVideo();
        }
    };

    destroy(){
        if(this.player !== null){
            this.player.destroy();
            this.player = null;
        }
    }
}


